import { Users } from "lucide-react";
import { EventPosition } from "@/pages/EventDetails";
import { SectionHeader } from "@/components/brand/SectionHeader";

interface EventEmployeesTableProps {
  eventPositions: EventPosition[];
}

/**
 * Who is working: a list of people, not a table of slots.
 *
 * The openings are deliberately absent. Available Positions, directly above,
 * already states them precisely.
 */
export default function EventEmployeesTable({
  eventPositions,
}: EventEmployeesTableProps) {
  // Sorted by name, because this is now read as a list of people. The table it
  // replaced sorted by position, which was the right key for a grid of slots
  // and the wrong one for answering "is so-and-so on this?".
  const working = eventPositions
    .flatMap((eventPos) =>
      eventPos.signedUpUsers.map((user) => ({
        key: `${eventPos.eventPositionId}-${user.id}`,
        name: `${user.firstName} ${user.lastName}`,
        position: eventPos.tableName,
      })),
    )
    .sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div className="p-4 sm:p-8">
      <SectionHeader icon={Users} className="mb-4">
        Who is working
      </SectionHeader>

      {working.length === 0 ? (
        <p className="text-sm text-muted-foreground">
          Nobody has signed up yet. Positions are listed above.
        </p>
      ) : (
        <div>
          {working.map((person) => (
            <div
              key={person.key}
              className="group -mx-3 flex items-baseline gap-2 rounded px-3 py-1.5 text-sm transition-colors hover:bg-primary/[0.04]"
            >
              <span className="shrink-0 text-foreground">{person.name}</span>
              <span
                aria-hidden
                className="leader-dots h-[0.9em] min-w-6 flex-1 text-primary/30"
              />
              <span className="shrink-0 text-muted-foreground transition-colors group-hover:text-foreground">
                {person.position}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
